import { gql } from "@apollo/client";

// violation_image_id (renamed from start_image_id, AUT-5830) is only the Hasura Action's
// officer-facing argument name -- api's own internal DTO/DB field for it is still startImageId/
// start_image_url under the hood, deliberately not renamed. That column is shared plumbing across
// every session type (park/double_park/capture/manual), where "start image" is the correct name
// for the automated flow; renaming it there would be a bigger, unrelated change touching the
// camera pipeline too. Hasura's action.yaml template maps this argument straight through to that
// field (`"startImageId": {{$body.input.violation_image_id}}`), so the rename is real but scoped
// to just where officers/reviewers actually see it.
export const CREATE_ENFORCEMENT_INTENT = gql`
  mutation CreateEnforcementIntent(
    $enforcementPolicyId: uuid!
    $violationAt: timestamptz!
    $licensePlateNumber: String!
    $licensePlateRegion: String
    $vehicleMake: String
    $vehicleModel: String
    $vehicleColor: String
    $officerNotes: String
    $streetAddress: String!
    $licensePlateImageId: uuid!
    $violationImageId: uuid!
    $sessionId: uuid!
  ) {
    create_enforcement_intent(
      enforcement_policy_id: $enforcementPolicyId
      violation_at: $violationAt
      license_plate_number: $licensePlateNumber
      license_plate_region: $licensePlateRegion
      vehicle_make: $vehicleMake
      vehicle_model: $vehicleModel
      vehicle_color: $vehicleColor
      officer_notes: $officerNotes
      street_address: $streetAddress
      license_plate_image_id: $licensePlateImageId
      violation_image_id: $violationImageId
      session_id: $sessionId
    ) {
      enforcementIntentId: enforcement_intent_id
      status
      voidedReason: voided_reason
      duplicateOfIntentId: duplicate_of_intent_id
    }
  }
`;

export interface CreateEnforcementIntentData {
  create_enforcement_intent: {
    enforcementIntentId: string;
    status: string | null;
    voidedReason: string | null;
    duplicateOfIntentId: string | null;
  };
}

export interface CreateEnforcementIntentVars {
  enforcementPolicyId: string;
  violationAt: Date;
  licensePlateNumber: string;
  licensePlateRegion?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleColor?: string;
  officerNotes?: string;
  streetAddress: string;
  licensePlateImageId: string;
  violationImageId: string;
  sessionId: string;
}

export default CREATE_ENFORCEMENT_INTENT;
